import _ from 'lodash';

import { AgentParticipantStatus } from 'models/routing_queue_item';
import InteractionType from 'models/interaction_type';

export function mapStateToProps({ getProvider }) {
  let currentAgent = getProvider('currentAgent').get();
  let customer = getProvider('profile').get();
  let customerId = _.get(customer, 'id');
  let activeSessionsProvider = getProvider('activeSessions');

  return {
    disableSubmit: !isAgentExistingChatParticipant(),
    shouldShowAcceptChat: shouldShowAcceptChat(),
  };

  function isAgentExistingChatParticipant() {
    let activeSession = activeSessionsProvider.findBy({ customer: { id: customerId } });
    return (
      activeSession &&
      activeSession.queueItem.getSessionByType(InteractionType.CHAT) &&
      activeSession.queueItem.getAgentParticipantStatus(currentAgent.id) === AgentParticipantStatus.ACTIVE
    );
  }

  function shouldShowAcceptChat() {
    let activeSession = activeSessionsProvider.findBy({ customer: { id: customerId } });
    let qi = activeSession && activeSession.queueItem;
    return (
      qi &&
      qi.isOffered() &&
      qi.getSessionByType(InteractionType.CHAT) &&
      // agent is offered for current customer
      qi.getAgentParticipantStatus(currentAgent.id) === AgentParticipantStatus.OFFERED &&
      // agent is assigned
      qi.getAssignedAgentId() === currentAgent.id
    );
  }
}
